import SideMenu from './SideMenu';
export default SideMenu;
export { default as SideMenu } from './SideMenu';